import 'twin.macro';

import * as R from 'ramda';
import React, { useContext, useEffect, useState } from 'react';
import { Step, Stepper as ReactStepper } from 'react-form-stepper';
import { useLocation } from 'react-router-dom';

import { DeviceInfoContext } from '@/contexts/device-info-context';

import { nr_steps } from '../app/utils/constants';
import { CheckIcon } from '../assets/images/icons/CheckIcon';

const steps = nr_steps.map((step, id) => {
  return {
    label: step.title,
    path: id + 1,
    substeps: step.path,
    completed: false
  };
});

const connectorStyleConfig = {
  activeColor: '#4FB84E',
  completedColor: '#4FB84E',
  size: 3
};

const styleConfig = {
  activeBgColor: '#4f9d3a',
  completedBgColor: '#4f9d3a'
};

const urlToArray = R.split('/');

const checkActiveStep = (pathname, originalSteps, data) => {
  const step = R.compose(R.last, urlToArray)(pathname);
  if (step === 'success') {
    return 8;
  }

  for (let i = 0; i < data.length; i++) {
    const element = originalSteps[i];
    if (element.path.includes(step)) {
      return i + 1;
    }
  }
};

const checkCompleteStatus = R.curry((active, originalSteps, data) => {
  return data.map((step, id) => {
    if (active === 8) {
      return { ...step, completed: true };
    }
    if (active - 1 > id) {
      return { ...step, completed: true };
    }
    return step;
  });
});

const Stepper = () => {
  const [allSteps, setAllSteps] = useState(steps);
  const [activeStep, setActiveStep] = useState(1);
  const { isMobile } = useContext(DeviceInfoContext);
  const url = useLocation();

  useEffect(() => {
    setActiveStep(checkActiveStep(url.pathname, nr_steps, allSteps));
  }, [url]);

  useEffect(() => {
    setAllSteps(checkCompleteStatus(activeStep, nr_steps, allSteps));
  }, [activeStep]);

  return (
    <>
      <div tw='bg-secondary sm:rounded-s20 sm:shadow-content'>
        <ReactStepper
          activeStep={activeStep - 1}
          connectorStateColors
          connectorStyleConfig={connectorStyleConfig}
          styleConfig={styleConfig}
          hideConnectors={isMobile}
        >
          {allSteps.map((step, index) => {
            return (
              <Step key={index} label={(!isMobile || activeStep === +step.path) && step.label} className='step-style'>
                {step?.completed ? <CheckIcon /> : <span>{step.path}</span>}
              </Step>
            );
          })}
        </ReactStepper>
      </div>
    </>
  );
};

export { Stepper };

// const Step = ({ data }) => {
//   return (
//     <div tw='flex flex-col items-center gap-1'>
//       <div tw='flex items-center justify-center w-[24px] h-[24px] bg-primary rounded-full'>
//         <SubBody text={data.path} twStyle={tw`text-tertiary`} />
//       </div>
//       <SubBody text={data.title} twStyle={tw`text-tertiary`} />
//     </div>
//   );
// };
